import { makeStyles } from '@material-ui/core';
import React from 'react';
import { COLOR_BLACK, COLOR_DARK_ORANGE, COLOR_SLATE_NAVY, COLOR_WHITE } from '../styles/colors';
import { FONT_PROXIMA_NOVA } from '../styles/fonts';
import clsx from 'clsx';

interface SubmitButtonProps {
  text: string,
  type?: 'button' | 'submit' | 'reset',
  className?: string,
  onSubmit?: () => void,
  disabled?: boolean,
}

const useStyles = makeStyles(theme => ({
  submitButton: {
    background: `linear-gradient(to left, ${COLOR_DARK_ORANGE} 50%, ${COLOR_SLATE_NAVY} 50%)`,
    backgroundSize: '200% 100%',
    backgroundPosition: 'right bottom',
    transition: 'background-position 0.5s ease-out',
    borderRadius: 30,
    border: '3px solid #3a3a3a',
    color: COLOR_BLACK,
    cursor: 'pointer',
    fontWeight: 700,
    minHeight: '54px',
    lineHeight: 1.2,
    width: '162px',
    padding: theme.spacing(1.25, 2.5),
    fontFamily: FONT_PROXIMA_NOVA,
    fontSize: theme.typography.pxToRem(16),

    '&:hover': {
      backgroundPosition: 'left bottom',
      backgroundColor: COLOR_DARK_ORANGE,
      border: `1px solid ${COLOR_SLATE_NAVY}`,
      boxShadow: 'none',
      color: COLOR_WHITE,
    },
  },
}), { name: SubmitButton.name });

export default function SubmitButton(props: SubmitButtonProps) {
  const { text, type = 'button', className, onSubmit, disabled = false } = props;
  const classes = useStyles();

  return (
    <button
      className={clsx(classes.submitButton, className)}
      onClick={onSubmit}
      disabled={disabled}
      type={type}
    >
      {text}
    </button>
  );
}
